import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { SignIn } from '@/features/auth/sign-in'
import { getSession } from '@/lib/auth-client'

const ZodSignInSearch = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  beforeLoad: async () => {
    const session = await getSession()
    if (session.data) {
      // Already logged in, redirect to dashboard
      throw redirect({
        to: '/',
      })
    }
  },
  component: SignIn,
  validateSearch: ZodSignInSearch,
})
